module.exports = __webpack_public_path__ + "media/images/icon_menu-e60464e326551211c179aed69407edf2.png";